export default "__VITE_ASSET__CPF3Aisp__"